<div class="avatar" [ngClass]="'avatar-' + size">
  <span>{{ initial }}</span>
</div>